import { useQuery } from "@tanstack/react-query";

export type Cie10Entry = { code: string; desc: string };

async function fetchCatalog(): Promise<Cie10Entry[]> {
  const res = await fetch("/cie10.json");
  if (!res.ok) throw new Error("No se pudo cargar el catálogo CIE-10");
  return res.json();
}

export function useCie10Catalog(enabled: boolean) {
  return useQuery({
    queryKey: ["cie10-catalog"],
    queryFn: fetchCatalog,
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
